import { memo, useCallback } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { IContact } from '../../model/types'

import { ContactPreviewContent } from './ContactPreviewContent'

import styles from './ContactPreview.module.scss'

type Props = {
  contact: IContact
  onClose: () => void
  isVisible?: boolean
}

export const ContactPreview = memo<Props>(({ isVisible, contact, onClose }) => {
  const renderContent = useCallback(() => {
    return <ContactPreviewContent contact={contact} />
  }, [contact])

  if (!isVisible) return null

  return (
    <ModalDialog
      classes={styles}
      content={renderContent}
      show={isVisible}
      onClose={onClose}
      size="lg"
    />
  )
})

ContactPreview.displayName = 'ContactPreview'
